import(/* webpackMode: "eager", webpackExports: ["PartnerLandingPage"] */ "/app/apps/platform-web/components/partner-app/PartnerLandingPage.tsx");
